module.exports = __webpack_public_path__ + "static/img/product_images_big35_h5_zh.c647560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big35_h5_zh.png
// module id = seMA
// module chunks = 34